const masks = [
	/^(-?\d{1,3})(\d{3})?(\d{3})?(\.\d{1,20})?$|^(-?\d{1,3})(\.?\d{3})?(\.?\d{3})?(,\d{1,20})?$/,	// Dec
	/^(-?\d{1,3})(\d{3})?(\d{3})?$|^(-?\d{1,3})(\.?\d{3})?(\.?\d{3})?$/,							// Int
	/^(\d{1,3})(\d{3})?(\d{3})?$|^(\d{1,3})(\.?\d{3})?(\.?\d{3})?$/,								// Pos
];

const store = function(g1, g2, g3, g4)
{
	return 	g1 + 
			(g2?.replace(this.ts, '') ?? '') + 
			(g3?.replace(this.ts, '') ?? '') + 
			(this.dp ? '.' + ((g4?.slice(1) ?? '') + '000000').slice(0, this.dp) : '');
};

const display = function(g1, g2, g3, g4)
{
	return 	g1 +
			(g2 ? this.ts + g2.replace(/[.,]/, '') : '') + 
			(g3 ? this.ts + g3.replace(/[.,]/, '') : '') +
			(this.dp ? this.ds + ((g4?.slice(1) ?? '') + '000000').slice(0, this.dp) : '');
};

export default function (...args)	// decimal_places, regex_option, decimal_separator, thousands_separator
{
	return {
		dp: args[0] ?? 0,		// Decimal places
		ds: args[2] ?? ',',		// Decimal separator
		ts: args[3] ?? '.',		// Thousands separator
		regex: masks[args[1] ?? 0],
		store_mask(match, a1, a2, a3, a4, b1, b2, b3, b4)
		{
			return (a1 ? store.call(this, a1, a2, a3, a4) : store.call(this, b1, b2, b3, b4));
		},
		display_mask(match, a1, a2, a3, a4, b1, b2, b3, b4)
		{
			return (a1 ? display.call(this, a1, a2, a3, a4) : display.call(this, b1, b2, b3, b4));
		}
	};
}

